import { z } from 'zod';

export const TemplateScalarFieldEnumSchema = z.enum(['templateId','cityId','templateName','templateType','defaultSet','template','width','height','emailType','description','reportType','disabled','displayOrder','groupName','whenDue','nextReminder','letterhead','letterVersion','notes']);

export default TemplateScalarFieldEnumSchema;
